/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// Mixins
import emailModalLauncher from 'shared/ui/mixins/modal-launchers/email';

const __vue_script__ = {
    name: 'ParticipantAvailability',

    mixins: [emailModalLauncher],

    props: {
        event: {
            required: true,
            type: Object
        },

        doc: {
            type: Object,
            default: null
        },

        parentModel: {
            type: Object,
            default: () => ({})
        },
    },

    data() {
        return {
            inviteUrl: null
        };
    },

    computed: {
        showInviteButtons() {
            return this.parentModel.status === 'awaiting' || this.parentModel.status === 'ready';
        },

        availabilityStatus() {
            const selectedTimeslot = this.parentModel.timeslot;

            if (selectedTimeslot === 'n/a') {
                return null;
            }

            if (this.doc.availability) {
                if (this.doc.availability.map(a => a.start).includes(selectedTimeslot)) {
                    return 'available';
                } else {
                    return 'not-available';
                }
            } else {
                return 'awaiting';
            }
        }
    },

    async created() {
        await this.setMeetingRequestUrl();
    },

    methods: {
        /**
         * Async resolution of the inviteUrl value
         */
        async setMeetingRequestUrl() {
            const eventId = this.event._id;
            const meetingRequestId = this.parentModel._id;
            const paxId = this.doc._id;

            if (!this.showInviteButtons) {
                return;
            }

            try {
                const { inviteUrl } = await this.$services.meetings.getMeetingRequestParticipantInviteUrl(eventId, meetingRequestId, paxId);
                this.inviteUrl = inviteUrl;
            } catch (e) {
                console.error('[ParticipantAvailability] Failed to get meetingRequestUrl for participant', e);
            }
        },

        /**
         * Email button handler
         */
        async onSendEmailClick() {
            if (!this.inviteUrl) {
                return;
            }
            this.openEmailModal(
                this.event,
                this.doc,
                {
                    meeting_organizer: this.parentModel.representative.label,
                    meeting_request_description: this.parentModel.description,
                    request_form_availability_url: this.inviteUrl
                },
                this.doc.fp_type
            );
        },

        /**
         * Copy invite URL to clipboard
         */
        async copyInviteUrl() {
            if (!this.inviteUrl) {
                return;
            }
            await navigator.clipboard.writeText(this.inviteUrl);
            this.$notify({
                group: 'flashes',
                text: this.$i18n.t('meetings.requests.notify.invite_url_copied').toString(),
            });
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "participant-availability" }, [
    this.availabilityStatus
      ? _c("span", { class: this.availabilityStatus }, [
          _vm._v(
            _vm._s(
              _vm.$t(
                "meetings.requests.participants.availability." +
                  this.availabilityStatus
              )
            )
          ),
        ])
      : _vm._e(),
    _vm.showInviteButtons
      ? _c("div", { staticClass: "availability-actions" }, [
          _c(
            "a",
            {
              staticClass: "has-action availability-action-button",
              attrs: {
                href: "#",
                disabled: !_vm.inviteUrl,
                "aria-label": _vm.$t(
                  "meetings.requests.participants.availability.copy_link_aria_label"
                ),
              },
              on: {
                click: function ($event) {
                  return _vm.copyInviteUrl()
                },
              },
            },
            [_c("i", { staticClass: "ic-link" })]
          ),
          _c(
            "a",
            {
              staticClass: "has-action availability-action-button",
              attrs: {
                href: "#",
                disabled: !_vm.inviteUrl,
                "aria-label": _vm.$t(
                  "meetings.requests.participants.availability.send_email_aria_label"
                ),
              },
              on: {
                click: function ($event) {
                  return _vm.onSendEmailClick()
                },
              },
            },
            [_c("i", { staticClass: "ic-mail" })]
          ),
        ])
      : _vm._e(),
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/meetings/meeting-requests/ParticipantAvailability.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__